<template>
  <div class="app">
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>

    <v-card color="grey lighten-4" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> E-Defter Schematron Kontrolü  </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-text-field
              flat=""
              solo-inverted=""
              hide-details
              v-model="search3"
              :label="$t('Search')"
              append-icon="search"
            >
            </v-text-field>

           
          </v-toolbar>
        </v-flex>
      </v-layout>
    </v-card>
    <v-container fluid>
  
              <v-layout row wrap="">
                <v-flex xs12 sm6 md2>
                  <tarihcomp
                    :etiket="$t('Starting-Date')"
                    v-bind:defaultvalue="'ok'"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                    v-model="searchdatestart"
                    v-bind:value="searchdatestart"
                  ></tarihcomp>
                </v-flex>

              

                <v-flex xs12 sm6 md2>
                  <tarihcomp
                    :etiket="$t('Finishing-Date')"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                    v-bind:defaultvalue="'ok'"
                    v-model="searchdateend"
                    v-bind:value="searchdateend"
                  >
                  </tarihcomp>
                </v-flex>
              

               
               
                <v-flex>
                  <v-layout>
                    <v-btn color="info" @click="getKontrol()" fab small="" dark>
                      <v-icon>search</v-icon>
                    </v-btn>

                 
                  </v-layout>
                </v-flex>
              </v-layout>
           
</v-container>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table
        :headers="headersFisTipi"
        :rows-per-page-items="[50, 100, 200, 500]"
        :loading="progress"
        :items="items"
        :search="search3"
      >
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <tr item>
            <td class="text-xs-left">{{ props.item.Id  }}</td>
            <td class="text-xs-left">{{ props.item.FisTarihi |  dateformat }}</td>
            <td class="text-xs-left">{{ props.item.FisNo }}</td>
            <td class="text-xs-left">{{ props.item.SiraNo  }}</td>
            <td class="text-xs-left">{{ props.item.Aciklama }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          {{ $t("No-records-searched-for", { value: search3 }) }}
        </v-alert>
      </v-data-table>
    </v-card>

    
  </div>
</template>

<script>
import tool from "@/components/app/coper/tools";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import auth from "@/api/auth";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import tarihcomp from "../../customcomp/tarihim";

export default {
  data() {
    return {
      searchdatestart:null,
      searchdateend:null,
      loadingvmodel: false,
      editDataDialog: false,
      insertDialog: false,
      deleteDialog: false,
      deleteData: {
        ID: 0,
        RecieptTypeName: null,
      },
      text1: null,
      snackbar: false,
      yetkidialog: false,
      headersFisTipi: [
        {
          text: "Id",
          value: "Id",
          align: "left",
        },
        {
          text: "Fis Tarihi",
          value: "FisTarihi",
          align: "left",
        },
        {
          text: "Fis No",
          value: "FisNo",
          align: "left",
        },
        {
          text: "Sıra No",
          value: "SiraNo",
          align: "left",
        },
        {
          text: "Aciklama",
          value: "Aciklama",
          align: "left",
        },
      ],
    
      loading: false,
      progress: false,
      items: [],
      search3: "",
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
    };
  },
  components: {
    tool,
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    tarihcomp
  },
  methods: {
   
    getKontrol() {

      var params = {
        DateStart:this.searchdatestart,
        DateEnd:this.searchdateend,
        CompanyID: this.credentials.MuhasebeSirketNo,
        UserID: this.credentials.UserID
      };
      this.loadingvmodel = true;
      this.$http
        .post(
          auth.API_URL + "api/AccountingParameters/EBookMissings",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.items = response.body;
            this.loadingvmodel = false;
            if (this.items.length ==0)
            {
              this.text1 = "Schematron Kontrolü Başarılı";
              this.snackbar = true;
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
  
  if (this.sayfayetki.Status == true) {
    
  } else {
    this.$refs.yetkidialog
      .open(this.sayfayetki.Message, this.sayfayetki.islem)
      .then((sonuc) => {
        if (sonuc == true) {
          if (this.prevRoute != null) {
            var url = "#" + this.prevRoute;

            window.open(url, "_self");
          } else {
            var mainUrl = "#/";
            window.open(mainUrl, "_self");
          }
        }
      });
  }

   
  },
  filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },
};
</script>

<style>
</style>